import { Moon, Sun } from '@phosphor-icons/react';
import { useTheme } from '../../hooks/useTheme';
import { useT } from '../../i18n';
import { haptic } from '../../lib/tma';

/** Moon in the light theme, sun in the dark one; the choice is remembered. */
export function ThemeToggle() {
  const t = useT();
  const theme = useTheme((s) => s.theme);
  const toggle = useTheme((s) => s.toggle);
  const dark = theme === 'dark';
  return (
    <button
      type="button"
      aria-label={dark ? t.shell.themeToLight : t.shell.themeToDark}
      onClick={() => {
        haptic('light');
        toggle();
      }}
      className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-surface text-fg transition-transform duration-150 active:scale-95"
    >
      {dark ? <Sun size={20} weight="bold" /> : <Moon size={20} weight="bold" />}
    </button>
  );
}
